export const CharactersEndpoints = {
	characterFullById: '/characters/{id}/full',
	characterById: '/characters/{id}',
	characterAnime: '/characters/{id}/anime',
	charactersManga: '/characters/{id}/manga',
	characterVoiceActors: '/characters/{id}/voices',
	characterPictures: '/characters/{id}/pictures',
	characterSearch: '/characters'
} as const
